import { lazyLoad } from 'utils/loadable';

export const CustomerSegmentPage = lazyLoad(
  () => import('./index'),
  module => module.CustomerSegmentPage
);
